(() => {
  const roots = () => Array.from(document.querySelectorAll('.pg17-advertorial-v2:not([data-pg17-adv-ready])'));
  const marketingKeys = /^(utm_.+|fbclid|gclid|ttclid)$/i;

  function preserveAttribution(root) {
    if (!/^https?:$/.test(window.location.protocol)) return;
    const inbound = new URLSearchParams(window.location.search);
    const retained = Array.from(inbound.entries()).filter(([key]) => marketingKeys.test(key));
    if (!retained.length) return;

    root.querySelectorAll('a[href^="/products/"]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      retained.forEach(([key, value]) => {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function wireSlider(slider) {
    const list = slider.querySelector('.splide__list');
    if (!list) return;
    list.setAttribute('role', 'list');
    list.tabIndex = 0;
    const amount = () => Math.max(280, Math.round(list.clientWidth * 0.82));
    const move = (direction) => list.scrollBy({ left: direction * amount(), behavior: 'smooth' });
    slider.querySelector('.splide__arrow--prev')?.addEventListener('click', (event) => {
      event.preventDefault();
      move(-1);
    });
    slider.querySelector('.splide__arrow--next')?.addEventListener('click', (event) => {
      event.preventDefault();
      move(1);
    });
    list.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
  }

  function init() {
    roots().forEach((root) => {
      root.dataset.pg17AdvReady = 'true';
      preserveAttribution(root);
      root.querySelectorAll('.splide').forEach(wireSlider);
      root.querySelectorAll('a[href="#scroll-to-top"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
